/**
 * Persian labels for the link-stats dimensions (apps/api links.logic
 * produces the keys). Shared by the partner and admin panels.
 */

/** Traffic sources, in the order they are listed when tied. */
export const TRAFFIC_SOURCES: Record<string, string> = {
  instagram: 'اینستاگرام',
  telegram: 'تلگرام',
  whatsapp: 'واتساپ',
  bale: 'بله',
  eitaa: 'ایتا',
  rubika: 'روبیکا',
  soroush: 'سروش',
  google: 'جستجوی گوگل',
  bing: 'جستجوی بینگ',
  yandex: 'جستجوی یاندکس',
  duckduckgo: 'داک‌داک‌گو',
  youtube: 'یوتیوب',
  aparat: 'آپارات',
  x: 'ایکس (توییتر)',
  facebook: 'فیسبوک',
  linkedin: 'لینکدین',
  pinterest: 'پینترست',
  reddit: 'ردیت',
  email: 'ایمیل',
  mizbanfa: 'سایت میزبان‌فا',
  website: 'سایت‌ها و وبلاگ‌ها',
  direct: 'مستقیم (بدون ارجاع)',
  other_app: 'برنامه‌های دیگر',
  unknown: 'نامشخص',
};

export const DEVICE_LABELS: Record<string, string> = {
  mobile: 'موبایل',
  tablet: 'تبلت',
  desktop: 'کامپیوتر',
  unknown: 'نامشخص',
};

export const OS_LABELS: Record<string, string> = {
  android: 'اندروید',
  ios: 'iOS (آیفون و آیپد)',
  windows: 'ویندوز',
  macos: 'مک',
  linux: 'لینوکس',
  other: 'سایر',
  unknown: 'نامشخص',
};

export const BROWSER_LABELS: Record<string, string> = {
  chrome: 'کروم',
  safari: 'سافاری',
  firefox: 'فایرفاکس',
  edge: 'اج',
  samsung: 'مرورگر سامسونگ',
  opera: 'اپرا',
  in_app: 'مرورگر داخل برنامه',
  other: 'سایر',
  unknown: 'نامشخص',
};

const regionNames = (() => {
  try {
    return new Intl.DisplayNames(['fa'], { type: 'region' });
  } catch {
    return null;
  }
})();

/** Persian country name for an ISO alpha-2 code; «نامشخص» for unknown. */
export function countryLabel(code: string): string {
  if (!/^[A-Z]{2}$/.test(code)) return 'نامشخص';
  try {
    return regionNames?.of(code) ?? code;
  } catch {
    return code;
  }
}
